export default __webpack_public_path__ + "static/media/casaduana_GeorginaEstrada.3baf7844.jpg";